<template>
  <div
    class="toolbar border-bottom"
    id="sx_toolbar"
    :class="{ 'mt-0': $isMobile() }"
  >
    <div
      id="sx_toolbar_container"
      :class="{
        'container-fluid': toolbarWidthFluid,
        'container-xxl': !toolbarWidthFluid,
      }"
      class="d-flex flex-stack"
    >
      <div
        data-sx-swapper="true"
        data-sx-swapper-mode="prepend"
        data-sx-swapper-parent="{default: '#sx_content_container', 'lg': '#sx_toolbar_container'}"
        class="page-title d-flex align-items-center flex-wrap ms-2 mb-lg-0"
        :class="{ 'mb-1': $isMobile() }"
      >
        <template
          v-if="
            this.breadcrumbs.length > 0
              ? this.breadcrumbs[0].name === 'HELP'
                ? true
                : false
              : false
          "
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </template>
        <template v-else>
          <h1 class="d-flex align-items-center text-dark fw-bolder my-1 fs-4">
            {{ title }}
          </h1>
          <span
            v-if="breadcrumbs"
            class="h-20px border-gray-200 mx-4 border-left-dashed"
          ></span>
          <ul
            v-if="breadcrumbs"
            class="breadcrumb breadcrumb-separatorless shadow-none fw-bold fs-7 my-1 ps-0"
          >
            <li class="breadcrumb-item pe-3 text-muted text-capitalize">
              <router-link :to="$appHomeUrl">
                {{
                  $t("Dashboard", {}, { locale: this.$store.state.activeLang })
                }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet w-5px h-2px"></span>
            </li>
            <template v-for="(item, index) in breadcrumbs" :key="index">
              <li class="breadcrumb-item text-muted" v-if="!item.isHtml">
                {{ item.name }}
              </li>
              <li class="breadcrumb-item text-muted" v-else>
                <span v-html="item.html"></span>
              </li>
              <li class="breadcrumb-item">
                <span class="bullet w-5px h-2px"></span>
              </li>
            </template>
            <li class="breadcrumb-item pe-3 text-dark">
              {{ title }}
            </li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { toolbarWidthFluid } from "@/core/helpers/config";

export default {
  name: "Toolbar",
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {},
  setup() {
    return {
      toolbarWidthFluid,
    };
  },
};
</script>
